import { render, staticRenderFns } from "./FormSaved.vue?vue&type=template&id=e4fa88ec&"
import script from "./FormSaved.vue?vue&type=script&lang=ts&"
export * from "./FormSaved.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports